import * as Yup from 'yup';
import { RegistrationNoticesType } from '../../static/types/commonTypes/registrationNoticesType';

export const registrationNoticesValidationSchema: Yup.ObjectSchema<RegistrationNoticesType> = Yup.object({
  numberProvided: Yup.mixed<'bordereau' | 'dossier'>()
    .oneOf(['bordereau', 'dossier'], 'Choix invalide')
    .required('Le choix du type de numéro est obligatoire'),

  bordereau: Yup.object({
    numeroBordereau: Yup.string().required('Le N° de bordereau est obligatoire'),
    numeroCase: Yup.string().required('Le N° de case est obligatoire'),
    numeroExtrait: Yup.string().optional().default(undefined),
  })
    .nullable()
    .when('numberProvided', {
      is: 'bordereau',
      then: (schema) => schema.required('Les informations du bordereau sont requises'),
      otherwise: (schema) => schema.nullable().default(null),
    }),

  dossier: Yup.object({
    numeroDossier: Yup.string().required('Le N° du dossier est obligatoire'),
    numeroReference: Yup.string().optional().default(undefined),
  })
    .nullable()
    .when('numberProvided', {
      is: 'dossier',
      then: (schema) => schema.required('Les informations du dossier sont requises'),
      otherwise: (schema) => schema.nullable().default(null),
    }),
});
